import TagsListModel from '../tags/TagsListModel'
export default class ManagerModel {
  constructor (data) {
    this.key = data.id
    this.id = data.id
    this.internalId = data.internalId
    this.children = []
    this.tags = new TagsListModel(data.tags)
    this.email = data.email || ''
    this.childrenNumber = data.childrenNumber
    this.birthDate = data.birthDate
    this.firstName = data.firstName || ''
    this.lastName = data.lastName || ''
    this.title = data.firstName + ' ' + data.lastName
    this.name = data.firstName + ' ' + data.lastName
    this.isActive = data.validTo === null
  }
}



// WEBPACK FOOTER //
// ./src/api/managers/ManagerModel.js